import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicarrentalservice() {



  const cardData =
  {
    keyword: 'Mumbai Car Rental Service ',
    heading: 'Shambhu Cabs: Mumbai Car Rental Service',
    headingDescription: 'Shambhu Cabs offers reliable and convenient Mumbai Car Rental Services, providing safe, comfortable, and fully customizable travel options for individuals, families, tourists, and corporate travelers across the city. Whether you need a car for local travel, airport transfers, business meetings, full-day rental, or outstation journeys, Shambhu Cabs ensures a smooth and hassle-free experience with its well-maintained fleet of hatchbacks, sedans, SUVs, luxury cars, and tempo travellers. Every ride is managed by trained and experienced chauffeurs who prioritize safety, punctuality, and comfort. With simple online booking, doorstep pickup from any location in Mumbai, Thane, or Navi Mumbai, affordable pricing, and 24/7 customer support, Shambhu Cabs makes renting a car in Mumbai effortless and reliable. Whether it’s daily commuting, weekend plans, or special occasions, Shambhu Cabs delivers dependable Mumbai car rental services designed for convenience, satisfaction, and a memorable travel experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Car Hire Mumbai",
    "description": "Car Hire Mumbai offers reliable and convenient vehicle rental solutions for all types of travelers. Whether you need a car for local city travel, airport transfers, or long-distance trips, this service provides well-maintained sedans, SUVs, and luxury cars with professional drivers or self-drive options. Flexible booking, transparent pricing, and 24×7 availability make it ideal for business, leisure, or family travel."
  },
  {
    "name": "Self-Drive Car Rental Mumbai",
    "description": "Self-Drive Car Rental Mumbai allows customers to explore the city and beyond at their own pace. The service provides a wide range of vehicles including sedans, SUVs, and premium cars, all thoroughly sanitized and well-maintained. With easy online booking, flexible rental periods, and competitive rates, travelers can enjoy the freedom and privacy of driving themselves."
  },
  {
    "name": "Chauffeur Driven Car Mumbai",
    "description": "Chauffeur Driven Car Mumbai offers luxury and comfort with professional drivers for local and outstation trips. Ideal for business executives, tourists, and families, the service guarantees punctual pickups, safe journeys, and well-maintained vehicles. Customers can book sedans, SUVs, or premium cars for single trips or extended travel with a dedicated chauffeur."
  },
  {
    "name": "24×7 Car Rental Mumbai",
    "description": "24×7 Car Rental Mumbai provides round-the-clock access to a variety of vehicles for spontaneous or planned travel. From city commutes to airport transfers and long-distance trips, customers can rely on professional service, prompt vehicle delivery, and fully maintained cars at any time of the day or night. Emergency bookings and flexible rental options are also available."
  },
  {
    "name": "Local Car Rental Mumbai",
    "description": "Local Car Rental Mumbai specializes in city travel with comfortable, clean, and reliable vehicles. Whether for office commutes, sightseeing, or shopping trips, customers can choose from hatchbacks, sedans, and SUVs with options for chauffeur-driven or self-drive rentals. Affordable pricing and flexible hourly or daily plans make it ideal for short-distance travel within Mumbai."
  },
  {
    "name": "Outstation Car Rental Mumbai",
    "description": "Outstation Car Rental Mumbai provides vehicles for long-distance travel across cities and states. Customers can book sedans, SUVs, or luxury cars with experienced chauffeurs for safe and comfortable journeys. Services include one-way trips, round trips, and custom travel itineraries, with transparent pricing and round-the-clock support for uninterrupted travel."
  },
  {
    "name": "Affordable Car Rental Mumbai",
    "description": "Affordable Car Rental Mumbai offers budget-friendly vehicle options without compromising on quality or service. Ideal for cost-conscious travelers, the service includes sedans, SUVs, and hatchbacks with self-drive or chauffeur-driven options. Transparent pricing, flexible booking, and reliable customer support ensure value for money for local and outstation travel."
  },
  {
    "name": "Luxury Car Rental Mumbai",
    "description": "Luxury Car Rental Mumbai provides high-end vehicles such as Mercedes, BMW, Audi, and premium SUVs for corporate, leisure, and special occasions. The service includes professional chauffeurs, well-maintained cars, and 24×7 support to ensure a comfortable and stylish journey. Perfect for weddings, events, VIP transfers, and city or outstation travel in style."
  },
  {
    "name": "Mumbai Airport Car Hire",
    "description": "Mumbai Airport Car Hire offers seamless pickup and drop services at Chhatrapati Shivaji International Airport. Customers can book sedans, SUVs, and luxury cars for comfortable airport transfers with professional chauffeurs. The service guarantees punctuality, safe travel, and hassle-free baggage handling for business travelers and tourists alike."
  },
  {
    "name": "SUV Car Rental Mumbai",
    "description": "SUV Car Rental Mumbai provides spacious and powerful vehicles suitable for family trips, long-distance travel, and group outings. Options include self-drive or chauffeur-driven rentals with modern amenities, safety features, and reliable service. Ideal for both city and highway travel, SUVs ensure comfort, luggage space, and smooth rides for all passengers."
  },
  {
    "name": "Sedan Car Rental Mumbai",
    "description": "Sedan Car Rental Mumbai offers comfortable, fuel-efficient, and stylish sedans for city commutes, airport transfers, and intercity travel. Customers can choose self-drive or chauffeur-driven options, with flexible booking, competitive pricing, and well-maintained vehicles. Sedans are ideal for couples, business travelers, and small families seeking comfort and reliability."
  },
  {
    "name": "Long-Term Car Rental Mumbai",
    "description": "Long-Term Car Rental Mumbai provides vehicles for weekly, monthly, or extended rentals. Perfect for corporate employees, long-stay travelers, or families, the service includes sedans, SUVs, and premium cars with well-maintained interiors, timely servicing, and flexible rental plans. Customers benefit from consistent quality and 24×7 support throughout the rental period."
  },
  {
    "name": "Corporate Car Rental Mumbai",
    "description": "Corporate Car Rental Mumbai delivers customized transportation solutions for businesses and corporate clients. Services include employee commute, airport transfers, client pickups, and long-distance travel with chauffeur-driven or self-drive options. The service ensures punctuality, professional drivers, well-maintained vehicles, and flexible corporate plans for organizations of any size."
  },
  {
    "name": "Premium Car Rental Mumbai",
    "description": "Premium Car Rental Mumbai offers high-end vehicles including luxury sedans, SUVs, and sports cars for business, leisure, and special occasions. With professional chauffeurs, luxury interiors, and round-the-clock customer support, passengers enjoy a stylish and comfortable travel experience for city trips, outstation journeys, and VIP events."
  },
  {
    "name": "Daily Car Rental Mumbai",
    "description": "Daily Car Rental Mumbai allows travelers to rent vehicles for short-term use, including hourly or daily packages. Available options include sedans, SUVs, and hatchbacks for self-drive or chauffeur-driven trips. This service is ideal for quick errands, city tours, or local commuting, providing flexibility, affordability, and reliable vehicles with timely delivery."
  },
  {
    "name": "Monthly Car Rental Mumbai",
    "description": "Monthly Car Rental Mumbai provides convenient vehicle rentals for extended periods. With sedans, SUVs, and premium cars available, the service is suitable for corporate employees, long-term travelers, and families. Benefits include competitive monthly pricing, well-maintained vehicles, flexible contracts, and 24×7 customer assistance for uninterrupted transportation."
  },
  {
    "name": "Online Car Rental Mumbai",
    "description": "Online Car Rental Mumbai offers easy and convenient booking through websites or mobile apps. Customers can select from a wide range of sedans, SUVs, and luxury vehicles for local, airport, and outstation travel. Transparent pricing, instant confirmation, and professional drivers make it a hassle-free solution for all car rental needs in Mumbai."
  }
],

"tableData": [
  ["Car Hire Mumbai", "Self-Drive Car Rental Mumbai"],
  ["Chauffeur Driven Car Mumbai", "24×7 Car Rental Mumbai"],
  ["Local Car Rental Mumbai", "Outstation Car Rental Mumbai"],
  ["Affordable Car Rental Mumbai", "Luxury Car Rental Mumbai"],
  ["Mumbai Airport Car Hire", "SUV Car Rental Mumbai"],
  ["Sedan Car Rental Mumbai", "Long-Term Car Rental Mumbai"],
  ["Corporate Car Rental Mumbai", "Premium Car Rental Mumbai"],
  ["Daily Car Rental Mumbai", "Monthly Car Rental Mumbai"],
  ["Online Car Rental Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Mumbai Car Rental Service with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides dependable Mumbai car rental services, perfect for city travel, airport transfers, and intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cars to ensure a smooth and comfortable ride across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are skilled and familiar with Mumbai routes, ensuring timely, safe, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai car rental experience worry-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Any Requirement",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your Mumbai travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cars are thoroughly cleaned and sanitized before every trip, ensuring a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai car rental journey comfortable and hassle-free."
  }
]






















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide Mumbai car rental services?',
    answer: 'Yes, Shambhu Cabs offers reliable car rental services in Mumbai for local travel, airport transfers, corporate trips, and outstation journeys.',
  },
  {
    question: 'How can I book a car rental in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free booking experience.',
  },
  {
    question: 'What types of vehicles are available for car rental in Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for individual, family, and corporate travel in Mumbai.',
  },
  {
    question: 'Are drivers experienced for Mumbai car rental services?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with Mumbai city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for car rentals in Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points according to your convenience and travel needs.',
  },
  {
    question: 'Is car rental service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock car rental services to fit your schedule and travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed for car rental services in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for car rental services in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for car rentals.',
  },
  {
    question: 'Is customer support available during car rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your car rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Shambhu Cabs’ car rental service in Mumbai is highly reliable. Clean vehicles, professional drivers, and excellent service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Highly satisfied with the Mumbai car rental service by Shambhu Cabs. Smooth booking process and comfortable rides.',
    rating: 5,
  },
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Car Rental Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-car-rental.jpg",
  "description": "Shambhu Cabs offers premium car rental services in Mumbai, including self-drive and chauffeur-driven cars. Choose from SUVs, sedans, and luxury vehicles for local rides, airport transfers, outstation trips, and corporate travel. Available 24×7 with flexible daily, monthly, and long-term rental options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-car-rental-service"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai Car Rental Service | Self-Drive & Chauffeur Cars | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book car rental services in Mumbai with Shambhu Cabs. Self-drive or chauffeur-driven SUVs, sedans, and luxury cars for local rides, airport transfers, outstation trips, and corporate travel. Flexible daily, monthly, and long-term rental options available 24×7."
  />

  <meta
    name="keywords"
    content="Car Hire Mumbai, Self-Drive Car Rental Mumbai, Chauffeur Driven Car Mumbai, 24×7 Car Rental Mumbai, Local Car Rental Mumbai, Outstation Car Rental Mumbai, Affordable Car Rental Mumbai, Luxury Car Rental Mumbai, Mumbai Airport Car Hire, SUV Car Rental Mumbai, Sedan Car Rental Mumbai, Long-Term Car Rental Mumbai, Corporate Car Rental Mumbai, Premium Car Rental Mumbai, Daily Car Rental Mumbai, Monthly Car Rental Mumbai, Online Car Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicarrentalservice;